<template>
  <v-form ref="form">
    <v-row class="pb-8">
      <v-col cols="12">
        <p class="primary--text form__title mb-5">
          DADOS DO PERFIL
        </p>
      </v-col>
      <v-col cols="12" class="mb-5" v-if="profileId">
        <v-switch
          v-model="profile.ativo"
          class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
          dense
          inset
          hide-details
          color="secondary"
        />
        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
          Status: {{ statusText }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" class="pr-sm-5">
        <BaseFormInput
          id-element="profileName"
          placeholder="Inserir"
          v-model="profile.nome"
          validate-on-blur
          required
          :rules="[requiredInput]"
          label-text="Nome do Perfil"
        />
      </v-col>
      <v-col cols="12" sm="3" class="pr-sm-5" v-if="userAreaIsGeral">
          <BaseFormSelect
            placeholder="Selecione"
            :items="areaOptions"
            v-model="profile.area"
            item-text="nome"
            item-value="id"
            :return-object="true"
            label-text="Área de Negócio"
            required
            :rules="[requiredInput]"
            @change="filterProfileOptions"
          />
        </v-col>
      <v-col cols="12" sm="3">
        <BaseFormSelect
          placeholder="Selecione"
          :items="structureOptions"
          v-model="profile.estrutura"
          item-text="nome"
          item-value="id"
          :return-object="true"
          label-text="Estrutura de Acesso"
          required
          :rules="[requiredInput]"
        />
      </v-col>
      <v-col cols="12" class="pt-4">
        <v-divider />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="primary--text form__title mb-5">
          MÓDULOS
        </p>
      </v-col>
      <v-col cols="12">
        <BaseDataTable
          :headers="tableHeaders"
          :items="profile.modulos"
          no-data-text="Não há módulos cadastrados."
          loading-text="Carregando módulos..."
          class="modules-table base__datatable"
          @click:row="$emit('click:module', $event)"
        >
          <template v-slot:[`item.nome`]="{ item }">
            <div :class="borderColor(item.habilitado)">
              <div class="modules-table__padding">
                {{ item.nome }}
              </div>
            </div>
          </template>
          <template v-slot:[`item.habilitado`]="{ item }">
            {{ enabledText(item.habilitado) }}
          </template>
        </BaseDataTable>
      </v-col>
    </v-row>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="3" class="mr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR'"
            class="error font-weight-bold"
            width="100%"
            :to="{ name: 'profile' }"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <BaseButton
            v-html="submitText"
            class="secondary font-weight-bold"
            width="100%"
            @click="$emit('click:submit')"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { requiredInput } from "@/utils/rules.js";
import { defaultFilterOptions } from "@/mixins/PayloadDataTableMixin";

const tableHeaders = [
  { text: "Módulos", value: "nome", sortable: true },
  { text: "Status", value: "habilitado", sortable: false }
];

const colorByStatus = {
  true: { color: "light-blue" },
  false: { color: "pink" }
};

export default {
  name: "ProfileForm",
  props: ["profile", "profileId", "structureOptions"],
  data: () => ({
    tableHeaders,
    requiredInput,
    filterOptions: defaultFilterOptions(),
    areaOptions: []
  }),
  async created() {
    this.areaOptions = await this.requestAreaSuggestion();
    if(this.profile.area == null) {
      this.profile.area = this.myInfo.area_usuario;
    }
  },
  computed: {
    ...mapState("me", ["myInfo", "userAreaIsGeral"]),
    statusText() {
      return this.profile.ativo ? "Ativo" : "Inativo";
    },
    submitText() {
      return this.profileId ? "SALVAR" : "ADICIONAR";
    },
  },
  methods: {
    ...mapActions("user", ["requestAreaSuggestion"]),
    borderColor(status) {
      const { color } = colorByStatus[status];
      return `modules-table__border-${color}`;
    },
    enabledText(enabled) {
      return enabled ? "Habilitado" : "Desabilitado";
    }
  }
};
</script>

<style lang="sass">
.modules-table
  &__border-light-blue
    border-left: 5px solid #49DCBB
  &__border-pink
    border-left: 5px solid #EF5350
  &__padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
  &.v-data-table.theme--light
    thead tr th
      padding: 8px 8px
    tbody tr td
      padding: 18px 8px
    tbody tr td:first-child
      padding: 2px 0px !important
</style>
